import { parseEventDateTime } from "./eventPublicStatus";

export const isCancellationEmailEvent = (event, now = new Date()) => {
  const showtime = parseEventDateTime(event);
  if (!showtime) return false;
  const nowMs = now instanceof Date ? now.getTime() : Number(now);
  return showtime.getTime() > nowMs;
};

export const archiveNeedsCancellationReason = (events, now = new Date()) =>
  (Array.isArray(events) ? events : []).some((event) => isCancellationEmailEvent(event, now));

export const formatEventWhen = (event) => {
  const date = String(event?.date || "").trim();
  const time = String(event?.time || "").trim();
  return [date, time].filter(Boolean).join(" | ");
};

export const recipientsForCancelledEvent = (tickets = [], emailByBuyerId = {}) => {
  const grouped = new Map();

  tickets.forEach((ticket) => {
    if (ticket?.refunded_at) return;
    const buyerId = ticket?.buyer_id;
    const email = String(emailByBuyerId[buyerId] || "").trim();
    if (!buyerId || !email.includes("@")) return;

    const current = grouped.get(buyerId) || { buyerId, email, ticketCount: 0 };
    current.ticketCount += 1;
    grouped.set(buyerId, current);
  });

  return [...grouped.values()];
};
